<template>
  <div>
    <div class="fm-flex fm-rela">
      <div
        style="
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
        "
        @click="disabled ? false : (showPopover = true)"
      ></div>
      <el-input
        :value="value ? value.name : ''"
        placeholder="请选择商品"
        style="width: 200px"
        suffix-icon="el-icon-arrow-right"
        readonly
        :disabled="disabled"
      ></el-input>
    </div>
    <el-dialog
      title="选择商品"
      append-to-body
      modal-append-to-body
      width="1000px"
      close-on-click-modal
      close-on-press-escape
      :visible.sync="showPopover"
    >
      <el-form inline :model="searchData">
        <el-form-item>
          <el-input
            placeholder="名称/备注"
            clearable
            prefix-icon="el-icon-search"
            v-model="searchData.searchInputValue"
            style="width: 200px"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="价格">
          <NumberRangeInput
            :precision="2"
            :minVal.sync="searchData.minPrice"
            :maxVal.sync="searchData.maxPrice"
            @change="changeAndSearch"
          ></NumberRangeInput>
        </el-form-item>
        <el-form-item>
          <el-button
            icon="el-icon-search"
            type="primary"
            size="mini"
            @click="changeAndSearch"
          >
            查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-refresh" size="mini" @click="resetAndSearch">
            重置
          </el-button>
        </el-form-item>
      </el-form>
      <el-form inline>
        <el-button
          icon="el-icon-delete"
          size="mini"
          plain
          type="danger"
          @click="select()"
        >
          清除已选
        </el-button>
      </el-form>
      <el-table
        v-loading="searchLoading"
        :data="searchRes && searchRes.data ? searchRes.data : []"
        stripe
        ref="refsTable"
        @sort-change="sortChange"
        max-height="300px"
      >
        <el-table-column
          fixed="left"
          prop="name"
          label="名称"
          width="200"
          align="left"
          header-align="center"
          sortable="custom"
        >
          <template slot-scope="scope">
            <div class="qs-line-3">{{ scope.row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="imageList"
          label="图片"
          width="120"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-image
              class="courseImage"
              :src="
                scope.row.imageList[0].sysFile.prefix +
                scope.row.imageList[0].sysFile.name
              "
              :preview-src-list="
                scope.row.imageList.map(
                  (d) => d.sysFile.prefix + d.sysFile.name
                )
              "
              v-if="scope.row.imageList.length > 0"
            >
            </el-image>
            <p v-qstype="'warning'" v-else>暂未上传</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="remainQuantity"
          label="剩余/总数"
          width="150"
          align="center"
          header-align="center"
        >
          <el-tooltip slot="header" placement="top">
            <div slot="content" v-html="'点击按剩余数量排序'"></div>
            <span>
              <i class="el-icon-question"></i>
              剩余/总数
            </span>
          </el-tooltip>
          <template slot-scope="scope">
            <span>
              {{ scope.row.remainQuantity }} / {{ scope.row.totalQuantity }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="price"
          label="价格"
          width="150"
          align="center"
          header-align="center"
          sortable="custom"
        >
          <template slot-scope="scope">
            ￥{{ scope.row.price.toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          min-width="150"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <p class="qs-line-3" v-qstype="scope.row.remark ? '' : 'warning'">
              {{ scope.row.remark || "—" }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="150"
          align="center"
          header-align="center"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          header-align="center"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            <el-button
              @click.native.stop="select(scope.row)"
              type="text"
              icon="el-icon-thumb"
            >
              选择
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="hideclose"
        v-if="searchRes && searchRes.pageInfo"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchRes.pageInfo.page"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="searchRes.pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchRes.total"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "QshpzyWebCustomerSelect",
  props: {
    value: {
      type: Object,
      default() {
        return null;
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    showPopover: {
      handler(newVal, val) {
        if (newVal) {
          this.search(true);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      showPopover: false,

      searchLoading: false,
      searchData: {
        searchInputValue: null,
        minPrice: null,
        maxPrice: null,
      },

      searchParam: {
        quickSearchInfoList: [
          {
            columns: ["name", "remark"],
            quickSearchValue: null,
          },
        ],
        minPrice: null,
        maxPrice: null,
        pageInfo: {
          page: 1,
          pageSize: 20,
        },
        sortInfo: null,
      },
      searchRes: {},
    };
  },

  mounted() {},

  methods: {
    select(item) {
      this.$emit("select", item);
      this.showPopover = false;
    },
    handleSizeChange(val) {
      this.searchParam.pageInfo.pageSize = val;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    handleCurrentChange(val) {
      this.searchParam.pageInfo.page = val;
      this.search(false, {
        showSuccessMessage: true,
      });
    },

    changeAndSearch() {
      this.searchParam.quickSearchInfoList[0].quickSearchValue =
        this.searchData.searchInputValue;
      this.searchParam.minPrice = this.searchData.minPrice;
      this.searchParam.maxPrice = this.searchData.maxPrice;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    resetAndSearch() {
      this.searchData = this.$options.data().searchData;
      this.changeAndSearch();
    },
    sortChange(val) {
      this.searchParam.sortInfo =
        val && val.order
          ? {
              columnName: val.prop,
              order: val.order.replace("ending", "").toUpperCase(),
            }
          : null;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    async search(init, args) {
      this.searchLoading = true;
      if (init) {
        this.searchParam.pageInfo.page = 1;
      }
      let requestRes = await this.$api.commodity_findByPageForSelect(
        this.searchParam,
        args
      );
      if (requestRes && requestRes.success) {
        this.searchRes = requestRes;
        this.searchRes.pageInfo = requestRes.pageInfo;
        this.$nextTick(() => {
          this.$refs.refsTable.doLayout();
        });
      }
      if (requestRes.pageCount == 0) {
        this.searchRes = null;
      }
      setTimeout(() => {
        this.searchLoading = false;
      }, 200);
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/CommoditySelectDialog.vue